// components/GlobalLoader.js - Your centralized loader using MUI
import React, { useState, useEffect } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const GlobalLoader = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Make loader available globally for ALL API calls
    window.setGlobalLoader = setLoading;
    
    // Cleanup when component unmounts
    return () => {
      window.setGlobalLoader = null;
    };
  }, []);

  return (
    <Backdrop 
      open={loading} 
      style={{ 
        zIndex: 9999,
        color: '#fff',
        backgroundColor: 'rgba(0, 0, 0, 0.7)'
      }}
    >
      <div style={{ textAlign: 'center', display: 'flex', gap: '16px', alignItems: 'center' }}>
        <CircularProgress 
          size={60}
          thickness={4}
          style={{ color: 'white' }} 
        />
        <div style={{ 
          marginTop: '16px', 
          fontSize: '16px', 
          fontWeight: '500' 
        }}>
          Loading...
        </div>
      </div>
    </Backdrop>
  );
};

export default GlobalLoader;